import { render, staticRenderFns } from "./SetupCreate.vue?vue&type=template&id=4e38e127&scoped=true&"
import script from "./SetupCreate.vue?vue&type=script&lang=js&"
export * from "./SetupCreate.vue?vue&type=script&lang=js&"
import style0 from "./SetupCreate.vue?vue&type=style&index=0&id=4e38e127&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38e127",
  null
  
)

export default component.exports